import api from "./api";

// As rotas de Parcelas são aninhadas sob um Financeiro:
//   /api/financeiro/{financeiroId}/parcelas
// O ParcelasController trata CRUD completo.

export async function listParcelas(financeiroId) {
  const { data } = await api.get(`/financeiro/${financeiroId}/parcelas`);
  return data;
}

export async function createParcela(financeiroId, payload) {
  const { data } = await api.post(`/financeiro/${financeiroId}/parcelas`, payload);
  return data;
}

export async function updateParcela(financeiroId, id, payload) {
  await api.put(`/financeiro/${financeiroId}/parcelas/${id}`, payload);
}

export async function deleteParcela(financeiroId, id) {
  await api.delete(`/financeiro/${financeiroId}/parcelas/${id}`);
}

// Helper — marca parcela como paga preservando o valor/vencimento
// e setando PagoEm para hoje (formato yyyy-MM-dd).
export async function marcarPaga(financeiroId, parcela) {
  const hoje = new Date().toISOString().slice(0, 10);
  await updateParcela(financeiroId, parcela.id, {
    valor: parcela.valor,
    vencimento: parcela.vencimento,
    pagoEm: hoje,
    pago: true,
  });
}

export async function desmarcarPaga(financeiroId, parcela) {
  await updateParcela(financeiroId, parcela.id, {
    valor: parcela.valor,
    vencimento: parcela.vencimento,
    pagoEm: null,
    pago: false,
  });
}
